import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { SecondaryLink } from 'components/core';

const Wrapper = styled.div`
  background: ${props => props.theme.colors.white.white};
  margin-top: 1rem;
  padding: 1rem;
  h5 {
    margin: 0 0 1rem 0;
    border-bottom: 1px solid ${props => props.theme.colors.white.dark};
  }
  ul {
    display: block;
    list-style-type: none;
    margin-left: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    padding-inline-start: 0;
  }
  li {
    display: grid;
    grid-template-columns: 1fr 3fr;
    grid-column-gap: 10px;
    align-items: center;
    img {
      margin: 0;
    }
    span {
      display: block;
    }
    .category {
      color: ${props => props.theme.colors.white.gray};
      text-transform: uppercase;
      font-size: .8em;
      margin: 0;
    }
  }
`;

const SidebarLinkSection = ({ title, isPostLink, links }) => (
  <Wrapper>
    <h5>{title}</h5>
    <ul>
      {links &&
        links.map(link => {
          return (
            <li key={link.title}>
              <img src={isPostLink ? link.coverImage.url : link.imageUrl} alt={title} />
              <div>
                {link.category && <span className='category'>{link.category.name}</span>}
                <SecondaryLink key={link.title} to={(isPostLink && link.slug) || null} href={(!isPostLink && link.path) || null} text={link.title} target='_blank' />
              </div>
            </li>
          );
        })}
    </ul>
  </Wrapper>
);

export default SidebarLinkSection;

SidebarLinkSection.propTypes = {
  title: PropTypes.string.isRequired,
  isPostLink: PropTypes.bool,
  links: PropTypes.array.isRequired
};
